export enum FieldType {
    string = "string",
    bool = "bool"
}
